export default __webpack_public_path__ + "static/media/406x619_Escoffier_ESource Platform Ads_Banner_2_V5.4d1edf2e.jpg";